import React from "react";
import { renderAmount } from "../../../utils";

const SUMMARY_FIELDS = [
  ["Subtotal", "subtotal"],
  ["Discounts", "discountTotal"],
  ["Tax", "taxTotal"],
  ["Fees", "feeTotal"],
  ["Credits", "creditTotal"],
  ["Grand total", "grandTotal"],
  ["Balance due", "balanceDue"],
];

const InvoiceSummary = ({
  totals = {},
  sourceRefs = [],
  discounts = [],
  fees = [],
  credits = [],
}) => {
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-[2fr,1fr]">
      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <h2 className="mb-3 text-lg font-semibold text-gray-900">Source refs</h2>
        {sourceRefs.length === 0 ? (
          <p className="text-sm text-gray-500">
            Manual-only invoices will not have source references yet.
          </p>
        ) : (
          <div className="space-y-2">
            {sourceRefs.map((sourceRef) => (
              <div
                key={`${sourceRef.sourceType}-${sourceRef.sourceId || sourceRef.label}`}
                className="rounded-md border border-gray-100 bg-gray-50 p-3"
              >
                <p className="text-sm font-medium text-gray-900">
                  {sourceRef.sourceNumber || sourceRef.sourceType}
                </p>
                <p className="text-sm text-gray-600">{sourceRef.label}</p>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <h2 className="mb-3 text-lg font-semibold text-gray-900">Totals</h2>
        <div className="space-y-2">
          {discounts.map((discount) => (
            <div
              key={discount.discountId || discount.localId}
              className="flex items-center justify-between rounded-md bg-gray-50 px-3 py-2 text-sm"
            >
              <span className="text-gray-600">
                {discount.name || "Discount"}{" "}
                <span className="text-xs text-gray-400">
                  {discount.type === "percentage"
                    ? `${discount.value}%`
                    : renderAmount(discount.value || 0)}{" "}
                  • {discount.timing === "postTax" ? "Post-tax" : "Pre-tax"}
                </span>
              </span>
              <span className="font-medium text-gray-900">
                -{renderAmount(discount.appliedAmount || 0)}
              </span>
            </div>
          ))}
          {fees.map((fee) => (
            <div
              key={fee.feeId || fee.localId}
              className="flex items-center justify-between rounded-md bg-gray-50 px-3 py-2 text-sm"
            >
              <span className="text-gray-600">
                {fee.name || "Fee"}{" "}
                <span className="text-xs text-gray-400">
                  {fee.type === "percentage"
                    ? `${fee.value}%`
                    : renderAmount(fee.value || 0)}{" "}
                  • {fee.timing === "preTax" ? "Pre-tax" : "Post-tax"}
                </span>
              </span>
              <span className="font-medium text-gray-900">
                +{renderAmount(fee.appliedAmount || 0)}
              </span>
            </div>
          ))}
          {credits.map((credit) => (
            <div
              key={credit.creditId || credit.localId}
              className="flex items-center justify-between rounded-md bg-gray-50 px-3 py-2 text-sm"
            >
              <span className="text-gray-600">
                {credit.name || "Credit"}{" "}
                <span className="text-xs text-gray-400">
                  {credit.type === "percentage"
                    ? `${credit.value}%`
                    : renderAmount(credit.value || 0)}{" "}
                  • {credit.timing === "preTax" ? "Pre-tax" : "Post-tax"}
                </span>
              </span>
              <span className="font-medium text-gray-900">
                -{renderAmount(credit.appliedAmount || 0)}
              </span>
            </div>
          ))}
          {SUMMARY_FIELDS.map(([label, key]) => (
            <div key={key} className="flex items-center justify-between text-sm">
              <span className="text-gray-600">{label}</span>
              <span className="font-medium text-gray-900">
                {renderAmount(totals[key] || 0)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InvoiceSummary;
